import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, ClipboardList, HeartPulse, LifeBuoy, ListChecks } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { tr } from "../lib/i18n";
import { LangToggle } from "./LangToggle";
import { ThemeToggle } from "./NavbarActions";

const MORE = [
  { to: "/life-admin", label: "Life admin", Icon: ListChecks },
  { to: "/executor-mode", label: "Executor mode", Icon: ClipboardList },
  { to: "/bereavement", label: "Bereavement pack", Icon: HeartPulse },
  { to: "/help", label: "Help", Icon: LifeBuoy },
];

// Phone & tablet navigation: the desktop link strip is hidden below lg, so every section lives in this sheet.
export const MobileNav = ({ items }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const row = ({ to, label, Icon }) => (
    <Link key={to} to={to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${to.slice(1).replace(/\//g, "-")}`}
      className={`flex items-center gap-3 rounded-xl px-3 h-11 text-sm font-medium transition-colors ${pathname.startsWith(to) ? "bg-primary/10 text-primary" : "text-foreground hover:bg-muted"}`}>
      <Icon className="h-4 w-4 shrink-0" /> {tr(label)}
    </Link>
  );
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-label={tr("Open menu")} data-testid="mobile-nav-btn" className="lg:hidden h-10 w-10 -ml-2 grid place-items-center rounded-full hover:bg-muted shrink-0">
        <Menu className="h-5 w-5" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-72 p-4 overflow-y-auto" data-testid="mobile-nav-sheet">
          <SheetHeader><SheetTitle className="font-serif text-left">{tr("Menu")}</SheetTitle></SheetHeader>
          <nav className="mt-4 space-y-1">{items.map(row)}</nav>
          <div className="mt-4 pt-4 border-t border-border space-y-1">{MORE.map(row)}</div>
          <div className="mt-4 pt-4 border-t border-border flex items-center gap-3"><LangToggle compact /><ThemeToggle /></div>
        </SheetContent>
      </Sheet>
    </>
  );
};
